import { render, staticRenderFns } from "./inteGroups.vue?vue&type=template&id=6d54ea9d"
import script from "./inteGroups.vue?vue&type=script&lang=js"
export * from "./inteGroups.vue?vue&type=script&lang=js"
import style0 from "./inteGroups.vue?vue&type=style&index=0&id=6d54ea9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports